import { ColumnType, MappingTable } from '@import/interfaces';
import { MappingTables } from '@import/types/mapping-tables.types';
import flatMap from 'lodash-es/flatMap';
import flattenDepth from 'lodash-es/flattenDepth';

// Returns all ColumnsTypes from Mapping Table Sections Config, Flattened into Single array
export function getMappingTableColumnTypes(employeeMappingTables: MappingTables): ColumnType[] {
    return flatMap(Object.values(employeeMappingTables), (mappingTable: MappingTable) => {
        if (!mappingTable.sections) {
            return [];
        }
        return flattenDepth(Object.values(mappingTable.sections), 1);
    });
}
